import axios from 'axios'

import { errorRequestInterceptor } from '../../../interceptors/http-interceptor/errorRequest'
import { errorResponseInterceptor } from '../../../interceptors/http-interceptor/errorResponse'
import { responseInterceptor } from '../../../interceptors/http-interceptor/response'
import { basicXLegacyTokenRequestInterceptor } from '../../../interceptors/http-interceptor/basicXLegacyToken'

export const configureBasicXLegacyTokenAPI = (url: string) => {
  const instance = axios.create({ baseURL: url })

  instance.interceptors.request.use(
    basicXLegacyTokenRequestInterceptor,
    errorRequestInterceptor
  )
  instance.interceptors.response.use(
    responseInterceptor,
    errorResponseInterceptor
  )

  return instance
}
